"use client";
import { Box, IconButton, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import { FaFilter } from "react-icons/fa";
import { IoIosPrint } from "react-icons/io";
import { FaFileCsv } from "react-icons/fa6";
import { MdGridOn } from "react-icons/md";
import { FaFilterCircleXmark } from "react-icons/fa6";

import GridLayoutSettingsDialog from "./GridLayoutSettingsDialogue";

const GridMenuOptions = ({
  gridRef,
  props,
  setGridCols,
  filterVisible,
  setFilterVisible,
}) => {
  const [showLayoutDialog, setShowLayoutDialog] = React.useState(false);
  const [currentGridProps, setCurrentGridProps] = React.useState({});

  const getActiveProps = () => {
    const grid = gridRef.current.instance;
    return {
      name: "DevExpress Grid",
      type: "dxgrid",
      props: {
        ...props,
        columnspecs: props.columnspecs.map((c, index) => ({
          visibleIndex: c.visibleIndex,
          format: c.format,
          alignment: c.alignment,
          visible: c.visible,
          Caption: c.Caption,
          Data: c.Data,
          Width: c.Width,
          columnEdit: c.columnEdit,
          allowEditing: c.allowEditing,
          allowExporting: c.allowExporting,
          allowFiltering: c.allowFiltering,
          allowFixing: c.allowFixing,
          allowGrouping: c.allowGrouping,
          allowHeaderFiltering: c.allowHeaderFiltering,
          allowHiding: c.allowHiding,
          allowReordering: c.allowReordering,
          allowResizing: c.allowResizing,
          allowSearch: c.allowSearch,
          allowSorting: c.allowSorting,
          autoExpandGroup: c.autoExpandGroup,
          cssClass: c.cssClass,
          dataType: c.dataType,
          fixed: c.fixed,
          fixedPosition: c.fixedPosition,
          showWhenGrouped: c.showWhenGrouped,
          showInColumnChooser: c.showInColumnChooser,
          showEditorAlways: c.showEditorAlways,
          propkey: c.propkey,
          selected: c.selected,
          proptype: c.proptype,
        })),

        // summary: {
        //   totalItems: grid.option("summary.totalItems"),
        //   groupItems: grid.option("summary.groupItems"),
        //   skipEmptyValues: grid.option("summary.skipEmptyValues"),
        //   recalculateWhileEditing: grid.option(
        //     "summary.recalculateWhileEditing"
        //   ),
        // },
        // export: grid.option("export"),
        // columnHidingEnabled: grid.option("columnHidingEnabled"),
        // editable: {
        //   canAdd: grid.option("editing.allowAdding"),
        //   canUpdate: grid.option("editing.allowUpdating"),
        //   canDelete: grid.option("editing.allowDeleting"),
        // },
        // pager: grid.option("pager"),
        // events: {
        //   onRowClick: grid.option("onRowClick"),
        //   onRowDblClick: grid.option("onRowDblClick"),
        // },
        // groupPanel: grid.option("groupPanel"),
        // stateStoring: grid.option("stateStoring"),
        // searchText: grid.option("searchPanel.text"),
        // rowDragging: grid.option("rowDragging"),
        // conditionalFormat: grid
        //   .option("columns")
        //   .map((col) => col.conditionalFormatting || [])
        //   .flat(),
        // filter: grid.getCombinedFilter(),
        // focusedRowEnabled: grid.option("focusedRowEnabled"),
        // filterPanel: grid.option("filterPanel"),
        // filterRow: grid.option("filterRow"),
        // selection: grid.option("selection"),
        // headerFilter: grid.option("headerFilter"),
        // focusedRowIndex: grid.option("focusedRowIndex"),
        // watch: grid.option("dataSource"),
        // columnChooser: grid.option("columnChooser"),
        // width: grid.option("width"),
        // autoNavigateToFocusedRow: grid.option("autoNavigateToFocusedRow"),
        // grouping: grid.option("grouping"),
        // paging: {
        //   pageIndex: grid.pageIndex(),
        //   pageSize: grid.pageSize(),
        // },
        // selectedRows: grid.getSelectedRowsData(),
      },
    };
  };

  const handleClick = () => {
    setCurrentGridProps(getActiveProps());
    setShowLayoutDialog(true);
  };

  const handleSaveLayout = () => {};

  const exportExcel = () => {
    gridRef.current?.instance.exportToExcel(false);
  };

  const toggleFilter = () => {
    const grid = gridRef.current?.instance;
    if (!grid) return;

    grid.option("filterRow.visible", !filterVisible);
    setFilterVisible(!filterVisible);
  };

  const printGrid = () => {};

  const buttons = [
    {
      key: "showExport",
      icon: <FaFileCsv />,
      onClick: exportExcel,
      tooltip: "Export CSV",
    },
    {
      key: "showFilter",
      icon: filterVisible ? <FaFilterCircleXmark /> : <FaFilter />,
      onClick: toggleFilter,
      tooltip: filterVisible ? "Hide Filter" : "Show Filter",
    },
    {
      key: "showGridSettings",
      icon: <MdGridOn />,
      onClick: handleClick,
      tooltip: "Grid Options",
    },
  ];

  const visibleButtons = props?.showGMO.visible
    ? buttons.filter((btn) => props?.showGMO[btn.key])
    : [];

  return (
    <>
      <GridLayoutSettingsDialog
        open={showLayoutDialog}
        onClose={() => setShowLayoutDialog(false)}
        currentGridProps={currentGridProps}
        setCurrentGridProps={setCurrentGridProps}
        setGridCols={setGridCols}
        layoutkey={props?.layoutkey}
      />
      <Box
        display="flex"
        alignItems="center"
        sx={{
          border: "1px solid #d1d1d1",
          background: "#f5f5f5",
          margin: "0px 10px",
        }}
      >
        {visibleButtons?.map((btn, index) => (
          <ToolbarButton
            key={index}
            icon={btn.icon}
            onClick={btn.onClick}
            tooltip={btn.tooltip}
          />
        ))}
      </Box>
    </>
  );
};

export default GridMenuOptions;

const ToolbarButton = ({ icon, onClick, tooltip }) => {
  return (
    <Box
      sx={{
        borderLeft: "1px solid #d1d1d1",
        "&:first-of-type": {
          borderLeft: "none",
        },
      }}
    >
      <Tooltip title={tooltip} arrow>
        <IconButton
          onClick={onClick}
          sx={{
            width: 36,
            height: 36,
            borderRadius: 0,
            color: "#444",
            "&:hover": {
              background: "#e6e6e6",
            },
          }}
        >
          {icon}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
